<template>
    <a-layout class="layout">
        <a-layout-header style="padding: 0px; width: 100%;">
            <div class="zx-header antd-pro-components-top-nav-header-index-head antd-pro-components-top-nav-header-index-light">
                <z-header></z-header>
            </div>
        </a-layout-header>

        <a-layout-content>
          <!-- <a-layout-sider>
            <Menu />
          </a-layout-sider> -->
          <router-view></router-view>
        </a-layout-content>

        <!-- <z-footer></z-footer> -->
    </a-layout>
</template>
<style lang="less">
   @import  '../assets/css/common.css';
   @import  '../assets/css/page.less';
   body {
      background:@background-color-light !important; 
   }
   .layout {
        min-height: 100vh;
        background: @background-color-light !important;
   }
</style>
<script>
    import ZHeader from '@/components/common/Header.vue'    
    //import ZFooter from '@/components/common/Footer.vue'
    import Menu from '../components/common/Menu'
    import {mapGetters} from 'vuex'
    import Vue from 'vue'

    export default {
        data(){
            return {
                collapsed: false
            }
        },
        computed: {
            ...mapGetters([
                'isSuperAdmin','isIntegrator'
            ])
        },
        components:{
            ZHeader,
            Menu
            //ZFooter
        },
        created() {
            if(this.$route.path == '/'){
                if(this.isSuperAdmin || this.isIntegrator){
                    Vue.ls.set('activeMenu', 1);
                    this.$router.push('/overview')
                }else{
                    Vue.ls.set('activeMenu', 1);
                    this.$router.push('/home')
                }
            }
        }
    }
</script>
<style lang="less" scoped>
.zx-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
}
</style>
